import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
	const { data, error } = await supabase.from('studentlessons').select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getDataWithType(type) {
	const { data, error } = await supabase.from('studentlessons').select().eq('type', type)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('studentlessons').select().eq('id', id)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getStudentIdData(id) {
	const { data, error } = await supabase.from('studentlessons').select().eq('studentId', id).eq('isActive', true)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('studentlessons').insert(adata).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	const { data, error } = await supabase.from('studentlessons').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('studentlessons').delete().eq('id', id)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
